import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-cart-success',
  templateUrl: './cart-success.component.html',
  styleUrl: './cart-success.component.scss',
  standalone: false,
})
export class CartSuccessComponent {
  @Input() public boughtCouponAmount = 0;

  constructor(
    public userService: UserService,
    private router: Router
  ) {}

  public toSeminarOverview() {
    this.router.navigate(['/home']);
  }
}
